import { BZ2_EDIT_DESCRIPTION_ERROR, BZ2_EDIT_PRICE_ERROR, BZ2_EDIT_TITLE_ERROR } from 'mk/autogenerated/translations/validators.6d0a14939917e3d0740356efbd22d0ed'
import { getPropertiesForCategories } from 'mk/bazaar/product/categories';
import { ProductEntity } from 'mk2/apps/bazaar/schemas';
import unicodeLetterRegex from 'unicode-7.0.0/General_Category/Letter/regex';

const titleAllowedSymbols = /[0-9_ &+\-"'/.,()]/;
const titleRepeat = /(.)\1\1\1/; // a character cannot be more than 3 times in a row
const titleWhiteSpace = /\s+/g;

export function validateTitle(value: string) {
    // PERF: this does very expensive checks (regexing characters one by one etc.)
    // might make sense to cache the stuff somehow

    // for validation-checking, we normalize whitespace
    value = value.replace(titleWhiteSpace, ' ').trim();

    const isAllowedCharacter = (char) => {
        return unicodeLetterRegex.test(char) || titleAllowedSymbols.test(char);
    };

    const onlyAllowedCharacters = (text) => {
        return text.split('').every(isAllowedCharacter);
    };

    const noDuplicates = (text) => {
        return !titleRepeat.test(text);
    };

    // let noForbidden = function(text) {
    //     text = ' ' + text.replace(titleAllowedSymbolsG,' ') + ' ';
    //     return !titleForbiddenWords.test(text);
    // };

    const noAllCaps = (text) => {
        return text.length <= 3 || text.substring(1).toUpperCase() !== text.substring(1);
    };

    const valid = onlyAllowedCharacters(value) && noDuplicates(value) && noAllCaps(value);

    return valid ? null : BZ2_EDIT_TITLE_ERROR;
}

export function validateDescription(value: string) {
    value = value.replace(/\n\n\n+/g, '\n\n');
    const valid = value.replace(/[^\n]/g, '').length < 50;

    return valid ? null : BZ2_EDIT_DESCRIPTION_ERROR;
}

export function validatePrice(value: string) {
    if (value === '') {
        return null;
    } else {
        value = value.replace(/,/g, '.').replace(/ /g, '');

        // we allow forms like "1234." or "1234.1"
        const valid = /^\d+(\.(\d\d?)?)?$/.test(value) && value.length <= 9;

        return valid ? null : BZ2_EDIT_PRICE_ERROR;
    }
}

export function hasValidProps(product: { properties: ProductEntity['properties'] }): boolean {
    const category = product.properties.find((p) => p[0] === 'cat');
    if (!category || category[1] === 'import') {
        return false;
    }

    const propertiesForCategory = getPropertiesForCategories([category[1]]);
    for (const prop of propertiesForCategory) {
        const found = product.properties.find((p) => p[0] === prop);
        if (!found) {
            return false;
        }
    }

    return true;
}
